import { render, staticRenderFns } from "./agregaPadecimiento.vue?vue&type=template&id=48ca7c48&"
import script from "./agregaPadecimiento.vue?vue&type=script&lang=js&"
export * from "./agregaPadecimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports